export type AnalyticsQueryParams = {
    from: string;
    to: string;
    propertyLabels?: string[];
    leadIngestionMethods?: string[];
};

export const queryKeys = {
    amiIncomeLimits: 'amiIncomeLimits',
    analyticsFunnel: 'analyticsFunnel',
    analyticsProperties: 'analyticsProperties',
    analyticsConversations: 'analyticsConversations',
    analyticsTours: 'analyticsTours',
    analyticsApplications: 'analyticsApplications',
    analyticsTeamPerformance: 'analyticsTeamPerformance',
    analyticsLeads: 'analyticsLeads',
    applications: 'applications',
    billingInfo: 'billingInfo',
    billingStatus: 'billingStatus',
    calendarIntegrations: 'calendarIntegrations',
    contacts: 'contacts',
    conversationsList: 'conversationsList',
    currentPlan: 'currentPlan',
    conversations: 'conversations',
    facebookIntegration: 'facebookIntegration',
    ringCentralIntegration: 'ringCentralIntegration',
    rentManagerIntegration: 'rentManagerIntegration',
    googleRedirectUrl: 'googleRedirectUrl',
    groups: 'groups',
    leads: 'leads',
    leadStageHistory: 'lead-stage-history',
    leadIngestionMethods: 'leadIngestionMethods',
    labels: 'labels',
    leadRoutingRules: 'leadRoutingRules',
    leadSources: 'leadSources',
    loggedInUser: 'loggedInUser',
    loggedInUserWithIngestEmailUsage: 'loggedInUserWithIngestEmailUsage',
    messages: 'messages',
    notifications: 'notifications',
    onboardingConfig: 'onboardingConfig',
    onboardingInvitation: 'onboardingInvitation',
    onboardingInvites: 'onboardingInvites',
    outlookRedirectUrl: 'outlookRedirectUrl',
    paymentMethods: 'paymentMethods',
    payments: 'payments',
    playbooksV2: 'playbooksV2',
    playbookTextTemplateVariables: 'playbookTextTemplateVariables',
    properties: 'properties',
    touringHours: 'touringHours',
    showings: 'showings',
    replySuggestions: 'replySuggestions',
    tourSlotSuggestion: 'tourSlotSuggestion',
    factSuggestions: 'factSuggestions',
    leadFacts: 'leadFacts',
    stripeClientSecret: 'stripeClientSecret',
    teamMembers: 'teamMembers',
    teamSettings: 'teamSettings',
    userStreaks: 'userStreaks',
    leadAttachments: 'leadAttachments',
    snippets: 'snippets',
    achievements: 'achievements',
    inboxes: 'inboxes',
    inboxFavorites: 'inboxFavoritesFavorites',
    orgTeams: 'orgTeams',
    listings: 'listings',
};
